import React, { Component } from 'react';

import ProjectContent from '../../../components/ProjectContent';
import '../../../css/views/project.css';

export default class ShopMe extends Component {
	render() {
		return (
			<div>
				<ProjectContent altTitle="Comment fonctionne Shop.me">
					<p className="text-detail">
						Shop.me repose sur un dispositif terrain constitué d’une application
						mobile, mise à la disposition d’un client/consommateur et un
						dispositif situé dans le point de vente, magasin ou ailleurs : un
						CMS accessible en mode SaaS (réservé au gestionnaire de
						l’établissement) et couplé à un/des récepteurs de type balise(s)
						appelé(s) Beacon(s).
					</p>
					<p className="text-detail">
						L’application mobile que possède le client peut être liée
						spécifiquement à une enseigne commerciale particulière. Dans ce
						cadre là, l’accès à l’offre Shop.me est également possible (un SDK
						est fourni par Arca Computing permettant une intégration facile de
						la solution dans une application mobile tierce). L’application
						mobile Shop.ME est présente sur les Smartphones des
						clients/consommateurs. Celle-ci a été téléchargée au préalable par
						le client ou est accessible dans une application spécifique. Elle
						est disponible sur Androïd et iOS.
					</p>
					<p className="text-detail">
						Une ou des balises de type Beacons (technologie Bluetooth LE) se
						signalent aux Smartphones qui sont dans leur environnement
						(géolocalisation indoor et/ou outdoor) et déclenchent l'envoi de
						messages sur l’application Shop.ME ou tierce sous la forme de
						notifications en mode push. Ces messages sont des offres, des
						promotions, des informations, des messages personnalisés et sont
						sous la forme de texte, lien url ou code barre. Le
						client/consommateur n’a plus qu’à lire l’information sur son
						Smartphone et décider de ce qu’il souhaite en faire (acceptation ou
						rejet). Au niveau du CMS, les données sont conservées et analysées ;
						des statistiques détaillées sont fournies permettant au responsable
						du point de vente de récolter un ensemble d’indicateurs précis sur
						la délivrabilité de ses messages et sur la qualité de sa campagne
						informative/promotionnelle :
					</p>
					<ul className="text-detail left">
						<li>- Mesure objective du temps de passage client.</li>
						<li>- Mesure du taux de passage.</li>
						<li>- Pics de fréquentation.</li>
						<li>- Heures de pointe.</li>
						<li>- Taux de conversion client.</li>
						<li>
							- Mesures d’efficacité de sa politique générale (qualité de
							l’offre/produits).
						</li>
						<li>Liste non exhaustive ...</li>
					</ul>
					<p className="text-detail">
						Le CMS est donc un outil d’administration des campagnes d’envoi, que
						l’on nomme « scénarios ». Le CMS intègre en standard différents
						scénarios. Il est à noter que le suivi statistique s’effectue en
						temps réel.
					</p>
					<p className="text-detail left">
						Quelques exemples d’utilisations possibles :
					</p>
					<ul className="text-detail left">
						<li>
							- Informer les clients ou visiteurs qui se trouvent à proximité
							d’une balise Beacon (envoi de contenus informatifs, envoi d'offres
							promotionnelles, ...).
						</li>
						<li>
							- Fidélisation et récompense des clients via un programme unique
							et adapté à son comportement et à ses habitudes d’achat.
						</li>
						<li>
							- Mesures et analyses statistiques récoltées à partir des passages
							clients afin d’optimiser le parcours de visite.
						</li>
						<li>
							- Ciblage de la communication du point de vente, en fonction de
							l'endroit où se trouve le client ou visiteur.
						</li>
					</ul>
				</ProjectContent>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/projet/fiches/ShopMe.js